import { VotingInterface } from '@/components/VotingInterface';
import { SurveyStatus } from '@/contracts/models/SurveyDto';
import { useTranslation } from '@/hooks/useTranslation';
import React, { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const MixerPage: React.FC = () => {
  const { surveyId } = useParams<{ surveyId: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [surveyStatus, setSurveyStatus] = useState<SurveyStatus | undefined>(
    undefined
  );

  const handleSurveyStatusLoaded = useCallback((status: string) => {
    setSurveyStatus(status as SurveyStatus);
  }, []);

  const handleTakeSurvey = () => {
    navigate(`/survey/${surveyId}/take`);
  };

  const isPublished = surveyStatus === 'published';

  if (!surveyId) {
    return (
      <main className='min-h-screen bg-gray-50 flex items-center justify-center p-4'>
        <div className='max-w-md text-center'>
          <i className='pi pi-exclamation-triangle text-orange-500 mb-3 text-5xl' />
          <h2 className='text-2xl font-semibold text-gray-900 mb-2'>
            {t('mixer.errors.title')}
          </h2>
          <p className='text-gray-600'>{t('mixer.errors.invalidSurveyId')}</p>
        </div>
      </main>
    );
  }

  return (
    <main className='min-h-screen bg-white py-8'>
      <div className='max-w-5xl mx-auto px-8'>
        <div className='w-full rounded-lg px-10 pt-6 pb-7 bg-gray-100 shadow-md'>
          {/* Header section - in outer gray container */}
          <div className='mb-5'>
            <h1 className='text-2xl font-bold mb-6 text-gray-900'>
              {t('voting.communityMixer')}
            </h1>

            <p className='text-gray-700 text-base mb-6 leading-relaxed'>
              {t('voting.communityMixerDescription')}
            </p>

            {isPublished && (
              <button
                onClick={handleTakeSurvey}
                className='h-11 rounded-md font-normal text-base inline-flex items-center justify-center gap-2 cursor-pointer transition-all duration-200 border px-6 bg-blue-700 border-blue-700 text-white hover:bg-blue-800'
              >
                <i className='pi pi-check-circle text-base' />
                <span>{t('surveyLanding.takeSurvey')}</span>
              </button>
            )}
          </div>

          {/* Voting interface - in white inner card */}
          <div className='bg-white rounded-lg p-10 shadow-sm'>
            <VotingInterface
              surveyId={surveyId}
              showHeader={false}
              onSurveyStatusLoaded={handleSurveyStatusLoaded}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default MixerPage;
